/**
 * [data-parsley-mindate="dd/mm/yyyy"] HTML attribute activates validation.
 */
export default class MinDate {
  constructor() {
    if (window.Parsley instanceof Object) {
      window.Parsley
        .addValidator('mindate', (value, req) => {
          const timestamp = Date.parse(this.transformDateStr(value));
          return !isNaN(timestamp) && timestamp > Date.parse(this.transformDateStr(req));
        })
        .addMessage('en', 'mindate', 'This date should be greater than %s');
    }
  }

  /**
   * Transforms `mm/dd/yyyy` to `dd/mm/yyyy` (https://momentjs.com/ can be used instead)
   * @param dateStr
   * @return {string}
   */
  transformDateStr(dateStr) {
    return dateStr.replace(/([0-9]+)\/([0-9]+)/, '$2/$1');
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/form/min-date.js